module.exports = __webpack_public_path__ + "static/media/machobanners_sm5.034e5521.png";